import { render, staticRenderFns } from "./ChangeSettings.vue?vue&type=template&id=31b6c14e&"
import script from "./ChangeSettings.vue?vue&type=script&lang=js&"
export * from "./ChangeSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports